export default ['expand', {
  props: {
    marks: {
      type: 'array',
      items: ['breakout'],
      optional: true
    }
  }
}];